<!--  -->
<template>
  <div class="courseCard courseCardDesc" v-if="courseTables && courseTables.descript">
    <div class="courseDescribe">
      <img src="@/assets/img/components/home/courseDescIcon.png" alt="" class="courseDescIcon" />
      <div class="describeText">
        {{ courseTables.descript }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  components: {},
  data() {
    return {
      courseTables: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    this.courseTables = this.$attrs.courseTables;
    // console.log(this.courseTables);
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang="scss" scoped>
.courseDescribe {
  // opacity: 0.02;
  display: flex;
  align-items: center;
  height: 58px;
  background: #ff7003;
  background-color: rgb(254, 250, 248);
  border-radius: 7px;

  .courseDescIcon {
    width: 16px;
    height: 18px;
    margin: 0 14px 0 22px;
  }

  .describeText {
    padding: 10px 0;
    overflow: hidden;
    color: #787878;
    font-weight: 400;
    font-size: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
